import "./App.css";
import { Nav, Footer } from "./components";
import { Routes } from "./routes";

function App() {
  return (
    <>
      <Nav />
      <Routes />
      <Footer />
    </>
  );
}

export default App;
